/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { DELETE_BOX } from "../graphql/deleteBox.mutation";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDeleteBoxMethods extends IPluginMethodMap {
  deleteBox(args: any): Promise<any>;
}

export class DeleteBoxService implements IAgentPlugin {
  readonly methods: IDeleteBoxMethods;

  constructor() {
    this.methods = {
      deleteBox: this.deleteBox.bind(this),
    };
  }

  async deleteBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    if (!args?.id) {
      throw new Error("Some unexpected error occurred.");
    }

    try {
      if (client) {
        const res = await client.mutate({
          mutation: DELETE_BOX,
          variables: {
            filter: {
              _id: args?.id,
            },
            reason: args?.reason,
            deleteIfFullyPaid: true,
            deleteReferral: args?.checkboxStatus ?? false,
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.deleteBox) {
          return {
            ...res?.data?.deleteBox,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
